module.exports = __webpack_public_path__ + "static/media/h_2.2e00f5fa.jpg";